import React from "react";

function Programsoffered() {  
  return (
    <div className="ABOUTmainContainer">
      <div className="allRightContent">
        <div className="textContainer">
          <h4 style={{ fontWeight: "bold" }}>
          Departments in which Ph.D. programme is offered
          <br />
          <br />
          </h4>
          <li>Computer Science & Engineering</li>
          <li>Electronics & Communication Engineering</li>
          <li>Information Technology</li><li>Mechanical Engineering</li>
          <li>Civil Engineering</li>
          <li>Metallurgical Engineering</li>
          <li>Electrical & Electronic Engineering</li>
          
          <br />
          <br />
          <h4 style={{ fontWeight: "bold" }}>
            First Ph.D awarded by JNTU-GV
            <br />
            <br />
          </h4>
          The first Ph.D. degree by the JNTU-GV University was awarded in the month of Dec-2023 to Dr. R. Gurunadha, 
            Vice-Principal &Controller of  Examinations of JNTU-GV for his research on “Analog Fault Modeling” under the
             esteemed guidance of Prof. K. Babulu of ECE dept &Director Admissions and R&D, JNTU-GV.
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  );
}

export default Programsoffered;
